import type { FaqFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

export const googleUxDesignFaqs = (productPrice: number): Array<FaqFragment> => {
  return [
    {
      id: '1',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What is the refund policy?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'If you subscribed, you get a 7-day free trial during which you can cancel at no penalty. After that, we don’t give refunds, but you can cancel your subscription at any time. '
          )}<a href="https://learner.coursera.help/hc/en-us/articles/208280266-Refund-policies">${_t(
          'See our full refund policy.'
        )}</a></text>
        </co-content>
      `,
      },
    },
    {
      id: '2',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Can I just enroll in a single course?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Yes! To get started, click the course card that interests you and enroll. You can enroll and complete the course to earn a shareable certificate, or you can audit it to view the course materials for free. When you subscribe to a course that is part of a Certificate, you’re automatically subscribed to the full Certificate. Visit your learner dashboard to track your progress.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '3',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is this course really 100% online? Do I need to attend any classes in person?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'This course is completely online, so there’s no need to show up to a classroom in person. You can access your lectures, readings and assignments anytime and anywhere via the web or your mobile device.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '4',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What is a UX designer?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'User experience (UX) designers focus on the experience that users have while using products like websites, apps, and physical objects. UX designers make those everyday interactions useful, enjoyable, and accessible. The role of an entry-level UX designer might include coming up with ideas to address user problems, conducting research with users, and designing wireframes, mockups, and prototypes.'
          )}</text>
          <text>${_t(
            'If you enjoy talking to and empathizing with people, drawing, thinking creatively, or paying attention to details, a job as a UX designer might be a good fit for you!'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '5',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Why start a career in UX design?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'As the digital world continues to expand, companies recognize that designing good user experiences is a necessity, which is why UX design is a high-growth and in-demand job field. UX designers create and organize products that people interact with daily, like mobile apps, websites, smart watches, and even physical products.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '6',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What background knowledge is necessary?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'None! Whether you’re completely new to the job field or have had some exposure, a Google Career Certificate is the right program for you.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '7',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Do I need to take the courses in a specific order?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'We highly recommend taking the courses of each certificate program in the order presented, as the content builds on information from earlier courses.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '8',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Which tools or platforms are included in the curriculum?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Figma and Adobe XD are the design tools taught in this certificate program. Spreadsheets, word processing applications, and presentation applications will also be used. Throughout the program, you will create a professional portfolio, using the platform of your choice, to showcase your UX design work.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '9',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What will I be able to do upon completing the professional certificate?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Google Career Certificates are designed to prepare you for an entry-level role in job fields like IT support, data analytics, project management, or UX design - whether that’s doing in-person or remote work, at a small company or a large enterprise organization. '
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '10',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Which jobs does this program prepare for?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'One of the most exciting parts about joining the field of user experience is the large number of job opportunities available. Nearly every company needs UX designers to help create their digital and physical products. While the need for UX designers continues to grow, there is currently a shortage of UX design professionals to fill those roles.'
          )}</text>
          <text>${_t(
            'A career in UX design allows you the opportunity to work as a generalist, finding a role as a UX designer, UI designer, or UX researcher, or as a specialist, like a visual designer or interaction designer. Upon completion of this certificate program, you will be able to search for jobs with all of these titles, and find the role that best suits you.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '11',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What resources will be available to help with the job search process?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            `In addition to expert-led training and hands-on projects designed to prepare you for a job, you'll get access to interview tips, mock interviews and resume building workshops, career coaching sessions and more.`
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '12',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What kind of companies hire UX design professionals?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Organizations of all kinds, in industries as varied as technology, finance, and advertising, need UX designers to develop products. '
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '13',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Why did Google create this program?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Google had long faced an issue that many other companies also contend with: they had open IT Support roles, and not enough qualified candidates to fill them. So they built and tested a training program to provide pathways to jobs in technical support at Google, for people with no college degree or experience. In 2018, Google launched the #{product}',
            { product: '' }
          )}<strong>IT Support Career Certificate</strong>${_t(
          ', so that this training could be available to everyone. Since then, thousands of people have completed the program, making it the top professional certificate program on Coursera. 82% of U.S. program graduates report a positive career outcome within 6 months of completion, such as getting a new job, promotion or raise.'
        )}</text>
          <text>${_t(
            'When Google saw the positive impact this program was having on people all over the world, they wanted to expand into additional fast-growing, high-paying career fields – Project Management, Data Analytics and UX Design. These certificates, built and taught by Google, are designed to prepare people from all backgrounds for jobs where there is great demand for qualified candidates.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '14',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is this program offered in other languages?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('This certificate is currently available globally in English. ')}</text>
        </co-content>
      `,
      },
    },
    {
      id: '15',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('How much does this certificate cost?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Now INR #{productPrice}!', { productPrice })}</text>
          <text>${_t(
            'In India, Coursera charges INR #{productPrice}/month after the initial 7 day free trial period. The certificate can be completed in less than 6 months of part time study. Google does not generate any revenue from Google Career Certificates and has made need-based financial assistance available.',
            { productPrice }
          )}</text>
        </co-content>
      `,
      },
    },
  ];
};

export default googleUxDesignFaqs;
